<template>
  <Modal
    :isShow="true"
    :isShowFooter="false"
    :isBackClickable="false"
    size="sm"
  >
    <Loader class="mx-auto" />
    <p class="text-center">{{ $t('banksPage.waitingAuth') }}</p>
    <div class="pb-3 text-center">
      <button class="btn btn-outline-danger btn-sm" v-if="!cancelDisabled" v-on:click="cancelAuth">Cancel authorization</button>
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { REQUEST_INTERVAL, REQUESTS_AMOUNT_LIMIT, sessionStatuses } from '../../constants'

export default {
  name: 'BanksListLoadingModal',
  data() {
    return {
      sessionCheckInterval: null,
      requestsAmount: 0
    }
  },
  props: {
    cancelDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuth', 'sessionStatus'])
  },
  mounted() {
    this.sessionCheckInterval = setInterval(() => this.getSession(), REQUEST_INTERVAL)
  },
  beforeDestroy() {
    clearInterval(this.sessionCheckInterval)
  },
  methods: {
    ...mapActions('auth', ['closeSession', 'getSessionStatus']),
    ...mapActions('personal', ['wipeAllData']),
    goToAccount() {
      this.isShowModal = false
      this.$router.push({ path: 'account' })
    },
    cancelAuth() {
      this.closeSession().then(() => { this.wipeAllData() })
      this.isShowModal = false
    },
    async getSession() {
      await this.getSessionStatus()

      if (this.isAuth) {
        clearInterval(this.sessionCheckInterval)
        this.goToAccount()
      }
      if (this.sessionStatus === sessionStatuses.Invalid) {
        clearInterval(this.sessionCheckInterval)
        this.isShowModal = false
      }
      this.requestsAmount++
      if (this.requestsAmount > REQUESTS_AMOUNT_LIMIT) {
        clearInterval(this.sessionCheckInterval)
      }
    }
  }
}
</script>
